// Why a view cannot be renamed or deleted while the schedules are still loading or could not be loaded.
export const VIEW_ACTIONS_BLOCKED_REASONS: Record<'loading' | 'ready' | 'failed', string | undefined> = {
  loading: 'Loading schedules...',
  ready: undefined,
  failed: 'The schedules could not be loaded. Reload the page to rename or delete views.'
};

export const viewNameTakenMessage = (name: string) => `A view named "${name}" already exists.`;

export const RENAME_NOT_SAFE_MESSAGE =
  'This view is part of a scheduled report, and the server cannot rename it safely yet. Reload the page, and try again once the update has finished.';
